import { createRoot } from 'react-dom/client';
import { ChakraProvider, createSystem, defaultConfig } from "@chakra-ui/react";
import { Provider } from 'react-redux';
import throttle from 'lodash/throttle';

import store from './store';
import App from './App';
import { saveState } from './store/LocalStorage';

const system = createSystem(defaultConfig, {
    theme: {
      tokens: {
        fonts: {
          body: { value: "Lato, sans-serif" },
          heading: { value: "Lato, sans-serif" },
        },
      },
    },
  });

store.subscribe(throttle(() => {
  const defaultReducer = store.getState().defaultReducer;
  saveState({ defaultReducer });
}, 1000));

const root = createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
      <ChakraProvider value={system}>
        <App />
      </ChakraProvider>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
